const CUSTOMER_ID_COOKIE_KEY = "euci_persisted";
const MONETATE_ID_COOKIE_KEY = "mt.v";
const MONETATE_ACCOUNT = "a-24f48522";
export {
  CUSTOMER_ID_COOKIE_KEY,
  MONETATE_ACCOUNT,
  MONETATE_ID_COOKIE_KEY
};
//# sourceMappingURL=constants.js.map
